import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { trackEvent } from "@/lib/gtag";
import { useAuth } from "@/context/AuthContext";
import Loader from "@/components/Loader";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const sid = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    const dest = localStorage.getItem("postLoginRedirect") || "/dashboard";

    (async () => {
      try {
        if (sid) {
          const res = await api.post("/auth/session", { session_id: sid });
          setUser(res.data.user);
          trackEvent("login", { method: "Google" });
        }
      } catch (e) {
        // fall through to navigation; ProtectedRoute will re-check
      } finally {
        localStorage.removeItem("postLoginRedirect");
        window.history.replaceState(null, "", window.location.pathname + window.location.search);
        navigate(dest, { replace: true });
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Loader label="Signing you in securely…" />;
}
